import { SidebarIdCsmApp } from '@jira/navigation-apps__constants/src/SidebarIdCsmApp.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { helpCenterSettingsCustomerAccessAppEntryPoint as main } from '@jira/spa-apps__help-center-settings-customer-access/src/HelpCenterSettingsCustomerAccessAppEntryPoint.entrypoint.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { csmAppSidebarEntryPoint } from '@jira/navigation-apps__sidebar-nav4-sidebars-content-csm-app/src/csmAppSidebarEntryPoint.entrypoint.tsx';
import { csmGlobalCustomerAccessSettingsResource } from '@jira/router-resources__admin-pages-csm-customer-access/src/csmGlobalCustomerAccessSettingsResource.tsx';
import { jsmGlobalCustomerAccessSettingsResource } from '@jira/router-resources__admin-pages-jsm-customer-access/src/jsmGlobalCustomerAccessSettingsResource.tsx';
import { getCustomerServiceL1NavigationResources } from '@jira/router-resources__customer-service-l1-navigation/src/getCustomerServiceL1NavigationResources.tsx';
import { csmExperienceCustomerAccessRoute } from '@jira/router-routes__help-center-settings-routes/src/csmExperienceCustomerAccessRoute.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { resourceWithCondition } from '@jira/router-resources__utils/src/resourceWithCondition.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { fg } from '@atlassian/jira-feature-gating';

import { getCsmExperiencesResources } from './getCsmExperiencesResources.tsx';

const csmExperienceCustomerAccessPageEntryPoint = createPageEntryPoint({
	main,
	leftSidebar: {
		sidebar: csmAppSidebarEntryPoint,
	},
});

export const csmExperienceCustomerAccessRouteEntry: Route = createEntry(
	csmExperienceCustomerAccessRoute,
	() => ({
		group: 'helpcenter-settings',
		perfMetricKey: 'help-center-settings.csm-experience-customer-access',
		layout: serviceProjectLayout,
		navigation: {
			sidebarId: SidebarIdCsmApp,
		},
		entryPoint() {
			return fg('csm_appification_standalone_navigation')
				? csmExperienceCustomerAccessPageEntryPoint
				: notFoundPageEntrypoint;
		},
		resources: [
			...getCustomerServiceL1NavigationResources(),
			...getCsmExperiencesResources(),
			jsmGlobalCustomerAccessSettingsResource,
			resourceWithCondition(
				() => fg('csm_customer_access_jsm_separation'),
				csmGlobalCustomerAccessSettingsResource,
			),
		],
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
